import request from "@/utils/request";

// 定义接口返回的数据结构
export interface LoginResponse {
  code: number;
  message: string;
  data: {
    token: string;
  };
}

// 手机验证码登录
export function login(data: {
  account: string;
  captcha: string;
  spread: null;
}) {
  return request.post("/api/oauth/mobileLogin", data);
}

// 扫码登陆绑定手机号
export function bindAndLogin(data: {
  phone: string;
  captcha: string;
  channel: number;
  unionId: string;
}) {
  return request.post("/api/oauth/bindAndLogin", data);
}

// 获取验证码
export function getCode(phone: object) {
  return request.post("/api/register/verify", phone);
}

// 退出登录
export function logout() {
  return request.post("/api/oauth/logout");
}

/**
 * 获取微信登录 state
 */
export function getWxLoginState() {
  return request.get("/api/oauth/wxloginOauth2");
}

/**
 * 轮询检查扫码状态
 * @param {string} state - 二维码状态码
 */
export function checkScanStatus(state: string | null) {
  return request.get("/api/oauth/checkScan?state=" + state);
}

// 获取用户信息
export function userInfo() {
  return request.get("/api/userinfo");
}

export interface orderVO {
  page?: number;
  limit?: number;
  type?: number; //订单状态,-1全部 默认为0未支付 1待发货 2待收货 3待评价 4已完成 5退款中 6已退款 7退款
  warehouseId?: number; //仓库id
  realName?: string; //收货人姓名
  userPhone?: string; //收货人电话
  orderId?: string; //订单号
}

// 订单列表
export function getOrderList(params: orderVO) {
  return request.get("/api/order/list", { params });
}
// interface OrderListResponse {
//   data: [{ orderId?: string }];
// }
// export function getOrderList(params: orderVO): Promise<OrderListResponse> {
//   return request.get("/api/order/list", { params });
// }

// 支付
export interface orderPayVO {
  from?: string;
  paytype?: string;
  uni?: string;
}
export function orderPay(data: orderPayVO) {
  return request.post("/api/order/pay", data);
}

// 订单详情
export function orderDetail(id: string | undefined) {
  return request.get("/api/order/detail/" + id);
}

//组合支付订单详情
export function previewDetail(data:any) {
  return request.get("/api/order/previewDetail/" + data.id);
}

//全额付款
export function allCombindPay(data: any) {
  return request.post("/api/h5/order/combindPay", data);
}

export function combinedOrder(data:any) {
  return request.get("/api/combinedOrder/list/" + data.id);
}

export function creadCombinedOrder(data: any) {
  return request.post("/api/order/creadCombinedOrder", data);
}

export function getStatus(data:any) {
  return request.get("/api/combinedOrder/detail/" + data.id);
}

export function resetCombinedOrder(data:any) {
  return request.post("/api/order/resetCombinedOrder",data);
}

